exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 700px) {\n.settings-button-wrapper[data-v-6eb73440] {\n    display: flex;\n    justify-content: center;\n}\n}\n", ""]);

// exports
